export default __webpack_public_path__ + "images/03b58f51128e5b76e9280c04ce6c39aa-Eventbrite_NYE_HomepageA_659x494.webp";